var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('product-attributes'),_c('hr'),_c('product-addons'),_c('hr'),_c('frequently-questions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }